import { FunctionComponent } from 'preact';
import { useSelector, useDispatch } from 'react-redux';
import { getKeepWatchingButtonId } from '../../htmlElements/htmlElementsIdGetter';
import { css } from '../../../../common/styles/styles.utils';
import {
  DISCOVERY_SKIPPABLE_CONTENT_KEEP_WATCHING_BUTTON,
  DISCOVERY_SMALL_SKIPPABLE_CONTENT_KEEP_WATCHING_BUTTON,
} from '../../discoveryPlugin.constants';
import { playerDataSelector } from '../../../../common/store/selectors/playerData.selector';
import { updateShowSkippableContent } from '../../store/discoveryPlugin.actions';
import { getKeepWatchingButtonStyleObject } from './keepWatchingButton.style';
import { useStyles } from '../../../../common/hooks/useStyles';
import { moreVideosSelector } from '../../../../common/store/selectors/moreVideos.selector';

const ARIA_LABEL = 'Keep watching this video';

interface KeepWatchingButtonComponentVariablesProps {
  showKeepWatching: boolean;
}

export const KeepWatchingButton: FunctionComponent<KeepWatchingButtonComponentVariablesProps> = props => {
  const { showKeepWatching } = props;

  const dispatch = useDispatch();
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqueId);
  const playerSize = useSelector(playerDataSelector.playerSize);
  const galleryView = useSelector(moreVideosSelector.galleryView);

  const smallSkippableContent = playerSize === 'medium' || (playerSize === 'large' && galleryView);

  const styles = useStyles(getKeepWatchingButtonStyleObject, [showKeepWatching, smallSkippableContent]);
  const { keepWatchingButtonStyle, keepWatchingTextStyle, keepWatchingButtonWrapperStyle } = styles;

  const onClickKeepWatching = (): void => {
    dispatch(updateShowSkippableContent(false));
  };

  const onKeyDownKeepWatching = (event: any): void => {
    if (event.key === 'Enter') {
      onClickKeepWatching();
    }
  };

  return (
    <div
      id={getKeepWatchingButtonId(playerUniqueId)}
      style={css(keepWatchingButtonWrapperStyle)}
      onClick={onClickKeepWatching}
      tabIndex={0}
      aria-label={ARIA_LABEL}
      onKeyDown={onKeyDownKeepWatching}
    >
      <div style={css(keepWatchingButtonStyle)}>
        <span style={keepWatchingTextStyle}>
          {smallSkippableContent ? DISCOVERY_SMALL_SKIPPABLE_CONTENT_KEEP_WATCHING_BUTTON : DISCOVERY_SKIPPABLE_CONTENT_KEEP_WATCHING_BUTTON}
        </span>
      </div>
    </div>
  );
};
